import React, { useState } from 'react'
import StoretitleCloudkitchen from '../../../composed/storetitle/storetitleCloudkitchen'

const CloudKitchenMenuDesktop = () => {

    const [selected, setSelected] = useState("brunch");

    const buttonStyle = (isSelected) => ({
        padding: "10px 20px",
        border: isSelected ? "none" : "1px solid #ccc",
        borderRadius: "5px",
        cursor: "pointer",
        backgroundColor: isSelected ? "#342870" : "white",
        fontFamily: isSelected ? 'Inter Bold' : 'Inter Regular',
        color: isSelected ? "#fff" : "gray",
        letterSpacing: '0.5px',
        transition: "background-color 0.2s ease",
        width: '300px',
        height: '60px',
        margin: '5px'
    });


    return (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', }}>

            <StoretitleCloudkitchen />

            <div style={{
                display: 'flex',
                flexDirection: 'row',
                marginLeft: '5px',
            }}>
                <button
                    style={buttonStyle(selected === "brunch")}
                    onClick={() => setSelected("brunch")}
                >
                    Brunch
                </button>
                <button
                    style={buttonStyle(selected === "dinner")}
                    onClick={() => setSelected("dinner")}
                >
                    Dinner
                </button>
            </div>

        </div>
    )
}

export default CloudKitchenMenuDesktop